import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(() => ({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,

  '& .SnackbarContainer-root': {
    position: 'absolute',
    top: 4,
    width: '100%',
    '& > div': {
      width: '100%',
    },
  },
}));
export default StyledBox;
